import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const SalesPersonRouteMiddleware = ({ fallbackPath }) => {
  const permissions = JSON.parse(sessionStorage.getItem("permissions"));

  if (
    permissions.sales_person_create === true ||
    permissions.sales_person_edit === true ||
    permissions.sales_person_view === true
  ) {
    return <Outlet />;
  } else {
    return <Navigate to={fallbackPath} />;
  }
};

export default SalesPersonRouteMiddleware;
